import { createReducer } from '@reduxjs/toolkit';
import type { IUserInfo } from '../../api/domain';
import { fetchUserInfoFailure, fetchUserInfoSuccess } from './user-info-api-actions';

interface IUserInfoApiState {
    userInfo?: IUserInfo;
}
export type { IUserInfoApiState };

export const initialState: IUserInfoApiState = {};

export const userInfoApiReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(fetchUserInfoSuccess, (state, { payload: userInfo }) => {
            state.userInfo = userInfo;
        })
        .addCase(fetchUserInfoFailure, (state) => {
            state.userInfo = undefined;
        });
});
